import React from 'react';
import { toast } from 'react-toastify';

import axios from 'axios';

import localization from '../localization';

export const errorHandler = (error, customToast, url) => {
  const { response } = error;
  const errorDetails = JSON.parse(localStorage.getItem('errorDetails'));
  const isErrorInPayment = response?.data.path?.split('/').includes('payments');

  let message = '';

  if (errorDetails) {
    message = (
      <div>
        <strong>Resource: </strong>
        <br />
        {url}
        <br />
        <strong>Message: </strong>
        <br />
        {response?.data?.message || error?.message}
      </div>
    );
  } else {
    switch (response?.status) {
      case 400:
        message = localization.t('errorNotifications.badRequest');
        break;
      case 401:
        message = localization.t('errorNotifications.unauthorized');
        break;
      case 403:
        isErrorInPayment
          ? (message = localization.t('errorNotifications.errorInPayment'))
          : (message = localization.t('errorNotifications.forbidden'));
        break;
      case 404:
        message = localization.t('errorNotifications.notFound');
        break;
      case 409:
        message = localization.t('errorNotifications.conflict');
        break;
      case 412:
        message = localization.t('errorNotifications.preconditionFailed');
        break;
      case 500:
        message = localization.t('errorNotifications.internalServerError');
        break;
      case 504:
        message = localization.t('errorNotifications.timeout');
        break;
      case 598:
      case 599:
        message = localization.t('errorNotifications.network');
        break;

      default:
        message = error.message || localization.t('errorNotifications.otherError');
    }
  }

  if (customToast) {
    return Promise.reject(message);
  }

  toast.error(message, {
    toastId: 'request-error-message',
    closeOnClick: false,
    autoClose: 15000,
    draggable: false,
    pauseOnFocusLoss: true,
    className: 'ErrorToast',
  });

  return Promise.reject(error);
};

export const SERVER = window.env.API_URL;

export const axiosInstance = axios.create({
  baseURL: SERVER,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response: { config: { url = '', method } = {} } = {} } = error;

    const customToast =
      (method === 'delete' && url.includes('/store')) || url.includes('/carts/subscription-offers');

    return errorHandler(error, customToast, url);
  },
);
